import { Flex } from "@chakra-ui/react";

function TableHeaderRow() {
  return (
    <>
      <Flex flex={1.75}>
        <Flex ml={8}>Categoria</Flex>
      </Flex>

      <Flex flex={0.7} justifyContent="center">
        Complemento
      </Flex>

      <Flex flex={0.7} justifyContent="center">
        Competência
      </Flex>

      <Flex flex={0.7} justifyContent="center">
        Vencimento
      </Flex>

      <Flex flex={0.7} justifyContent="center">
        Liquidação
      </Flex>

      <Flex flex={0.7} justifyContent="center">
        Crédito
      </Flex>

      <Flex flex={1} justifyContent="center" textAlign="center">
        Centro de custo
      </Flex>

      <Flex flex={0.6} justifyContent="flex-end">
        Valor
      </Flex>

      <Flex flex={1}>Conta bancária</Flex>

      <Flex flex={1.75}>Descrição</Flex>

      <Flex flex={0.8}>Nosso Número</Flex>
    </>
  );
}

export default TableHeaderRow;
